import { useNavigate, useSearchParams } from 'react-router-dom';
import TopBar from '../components/TopBar';
import BottomNav from '../components/BottomNav';
import { useLang } from '../LangContext';
import { useT } from '../i18n';

export default function ErrorScreen() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const type = params.get('type') || 'expired'; // 'expired' | 'insufficient' | 'used'
  const { lang } = useLang();
  const t = useT(lang);

  const TABS = [
    { key: 'used',         label: t('usedTab') },
    { key: 'expired',      label: t('expiredTab') },
    { key: 'insufficient', label: t('insufficientTab') },
  ];

  // ── Expired content ──────────────────────────────────────
  const ExpiredContent = () => (
    <>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: 32, padding: 32,
        display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
        boxShadow: '0px 12px 32px rgba(45,45,66,0.06)',
        border: '1px solid #f2efff',
        marginBottom: 20,
      }}>
        {/* Icon */}
        <div style={{
          width: 80, height: 80, borderRadius: '50%',
          backgroundColor: '#FFF8E6',
          border: '2px solid #F9CC61',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: 24,
        }}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="#BA7517">
            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>
          </svg>
        </div>
        <h2 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 700, fontSize: 20, color: '#2d2d42', marginBottom: 16,
        }}>{t('barcodeExpiredTitle')}</h2>
        <p style={{ fontSize: 13, color: '#5a5971', lineHeight: 1.7, maxWidth: 280, marginBottom: 32 }}>
          {t('barcodeExpiredDesc')}
        </p>
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 12 }}>
          <button
            onClick={() => navigate('/barcode')}
            style={{
              height: 52, width: '100%',
              backgroundColor: '#FF5C36', color: '#ffffff',
              border: 'none', borderRadius: 14,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700, fontSize: 14, cursor: 'pointer',
              boxShadow: 'inset 0px 2px 4px rgba(255,255,255,0.3)',
              transition: 'transform 0.15s',
            }}
          >{t('regenerate')}</button>
          <button
            onClick={() => navigate('/')}
            style={{
              height: 52, width: '100%',
              backgroundColor: 'transparent',
              border: '1px solid #b02600', color: '#b02600',
              borderRadius: 14,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700, fontSize: 14, cursor: 'pointer',
              transition: 'transform 0.15s',
            }}
          >{t('returnHome')}</button>
        </div>
        <p style={{ marginTop: 24, fontSize: 11, color: 'rgba(90,89,113,0.6)' }}>
          {t('helpText')}
        </p>
      </div>

      {/* Decorative bento cards */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
        <div style={{
          backgroundColor: '#f2efff', borderRadius: 24, padding: 16,
          height: 160, overflow: 'hidden', position: 'relative',
          display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
        }}>
          <div>
            <span style={{ fontSize: 10, fontWeight: 700, color: '#00614e', textTransform: 'uppercase', letterSpacing: '0.07em' }}>
              {t('quickHelp')}
            </span>
            <h3 style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700, fontSize: 16, color: '#2d2d42', marginTop: 4, lineHeight: 1.2,
            }}>{t('faqSupport')}</h3>
          </div>
          <div style={{ position: 'absolute', bottom: -16, right: -16, opacity: 0.15 }}>
            <svg width="80" height="80" viewBox="0 0 24 24" fill="#2d2d42">
              <path d="M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2zm1 14.5h-2v-2h2v2zm0-4h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z"/>
            </svg>
          </div>
        </div>

        <div style={{
          backgroundColor: 'rgba(249,204,97,0.1)',
          border: '1px solid rgba(249,204,97,0.2)',
          borderRadius: 24, padding: 16,
          height: 160, overflow: 'hidden', position: 'relative',
          display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
        }}>
          <div>
            <span style={{ fontSize: 10, fontWeight: 700, color: '#745700', textTransform: 'uppercase', letterSpacing: '0.07em' }}>
              {t('memberBenefits')}
            </span>
            <h3 style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700, fontSize: 16, color: '#2d2d42', marginTop: 4, lineHeight: 1.2,
            }}>{t('doublePointsDay')}</h3>
          </div>
          <div style={{ position: 'absolute', bottom: -8, right: -8, width: 60, height: 60 }}>
            <div style={{
              width: 60, height: 60, borderRadius: '50%',
              background: 'linear-gradient(135deg, #f9cc61, #FF5C36)',
              transform: 'rotate(12deg)',
            }}/>
          </div>
        </div>
      </div>
    </>
  );

  // ── Insufficient content ─────────────────────────────────
  const InsufficientContent = () => (
    <>
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
        gap: 20, marginBottom: 28,
      }}>
        {/* Icon */}
        <div style={{
          position: 'relative',
          width: 80, height: 80, borderRadius: '50%',
          backgroundColor: '#FFF8E6',
          border: '2px solid #f9cc61',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="#BA7517">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
          </svg>
          {/* Pulse dot */}
          <div style={{
            position: 'absolute', top: -2, right: -2,
            width: 14, height: 14, borderRadius: '50%',
            backgroundColor: '#FF5C36', opacity: 0.4,
          }}/>
        </div>

        <div>
          <h1 style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 800, fontSize: 20, color: '#2d2d42', marginBottom: 10, letterSpacing: '-0.02em',
          }}>{t('insufficientTitle')}</h1>
          <p style={{ fontSize: 13, color: '#5a5971', lineHeight: 1.7, padding: '0 8px' }}>
            {t('insufficientDesc')}
          </p>
        </div>

        {/* Progress card */}
        <div style={{
          width: '100%',
          backgroundColor: '#ffffff',
          borderRadius: 24, padding: 24,
          boxShadow: '0px 12px 32px rgba(45,45,66,0.06)',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 14 }}>
            <div style={{ textAlign: 'left' }}>
              <span style={{ fontSize: 9, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#5a5971', fontWeight: 700 }}>
                {t('currentPts')}
              </span>
              <div style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 800, fontSize: 18, color: '#2d2d42', marginTop: 2,
              }}>20 {t('pointsUnit')}</div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <span style={{ fontSize: 9, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#b41340', fontWeight: 700 }}>
                {t('stillNeeded')}
              </span>
              <div style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 800, fontSize: 18, color: '#b41340', marginTop: 2,
              }}>30 {t('pointsUnit')}</div>
            </div>
          </div>

          {/* Progress bar */}
          <div style={{
            width: '100%', height: 10,
            backgroundColor: '#e2dfff',
            borderRadius: 9999, overflow: 'hidden', marginBottom: 14,
          }}>
            <div style={{
              width: '40%', height: '100%',
              backgroundColor: '#FF5C35',
              borderRadius: 9999,
            }}/>
          </div>

          {/* Mini stats */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            {[
              { label: t('requiredPoints'), value: '50 Points' },
              { label: t('completionRate'), value: '40%' },
            ].map(({ label, value }) => (
              <div key={label} style={{
                backgroundColor: '#f2efff', borderRadius: 12, padding: '10px 12px', textAlign: 'left',
              }}>
                <span style={{ display: 'block', fontSize: 9, color: '#5a5971', marginBottom: 4 }}>{label}</span>
                <span style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 700, fontSize: 13, color: '#2d2d42',
                }}>{value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Quick earn tip */}
      <div style={{
        position: 'relative', overflow: 'hidden',
        borderRadius: 24, padding: 20, marginBottom: 20,
        backgroundColor: 'rgba(176,38,0,0.05)',
        display: 'flex', alignItems: 'center', gap: 14,
      }}>
        <div style={{
          position: 'absolute', inset: 0, opacity: 0.1, pointerEvents: 'none',
          background: 'radial-gradient(circle at 20% 50%, #FF5C35 0%, transparent 50%)',
        }}/>
        <div style={{
          flexShrink: 0, width: 60, height: 60, borderRadius: 12,
          backgroundColor: '#ffffff',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          position: 'relative', zIndex: 1,
        }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="#b02600">
            <path d="M19.48 12.35c-1.57-4.08-7.16-4.3-5.81-10.23c.1-.44-.37-.78-.75-.55C9.29 3.71 6.68 8 8.87 13.62c.18.46-.37.89-.75.59C6.75 12.96 6.5 11.88 6.5 11c0-.44-.5-.68-.83-.42C4.2 11.66 3 13.32 3 15.47c0 3.35 2.67 6.03 6.02 6.03c-3.55-4.19-.25-8.07 2.66-9.01c-.08 2.38 1.17 5.3 2.85 6.83c.87-3.01 1.34-5.36-.48-7.55c1.8 1.46 5.71 6.65 3.32 11.38c0 .02-.01.03-.02.05C19.72 22.01 21 20.36 21 18.5c0-2.54-1.46-4.53-1.52-6.15z"/>
          </svg>
        </div>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <h4 style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 700, fontSize: 13, color: '#2d2d42', marginBottom: 2,
          }}>{t('quickEarnTip')}</h4>
          <p style={{ fontSize: 11, color: '#5a5971' }}>{t('quickEarnDesc')}</p>
        </div>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="rgba(176,38,0,0.3)" style={{ marginLeft: 'auto', flexShrink: 0 }}>
          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
        </svg>
      </div>

      {/* Actions */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <button
          onClick={() => navigate('/')}
          style={{
            height: 52, width: '100%',
            backgroundColor: '#FF5C36', color: '#ffffff',
            border: 'none', borderRadius: 12,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 700, fontSize: 14, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            boxShadow: '0 4px 16px rgba(255,92,54,0.25)',
          }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          {t('howToEarn')}
        </button>
        <button
          onClick={() => navigate('/')}
          style={{
            height: 52, width: '100%',
            backgroundColor: 'transparent',
            border: '2px solid #FF5C36', color: '#FF5C36',
            borderRadius: 12,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 700, fontSize: 14, cursor: 'pointer',
          }}
        >{t('returnHome')}</button>
      </div>

      <p style={{ marginTop: 40, textAlign: 'center', fontSize: 11, color: '#5a5971', fontWeight: 500 }}>
        {t('helpText')}
      </p>
    </>
  );

  // ── Used content ─────────────────────────────────────────
  const UsedContent = () => (
    <div style={{
      backgroundColor: '#ffffff',
      borderRadius: 32, padding: 32,
      display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
      boxShadow: '0px 12px 32px rgba(45,45,66,0.06)',
    }}>
      <div style={{
        width: 80, height: 80, borderRadius: '50%',
        backgroundColor: '#f2efff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: 20,
      }}>
        <svg width="40" height="40" viewBox="0 0 24 24" fill="#75748d">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
        </svg>
      </div>
      <h2 style={{
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontWeight: 700, fontSize: 20, color: '#2d2d42', marginBottom: 12,
      }}>{t('usedTitle')}</h2>
      <p style={{ fontSize: 13, color: '#5a5971', lineHeight: 1.7, maxWidth: 280, marginBottom: 28 }}>
        {t('usedDesc')}
      </p>
      <button
        onClick={() => navigate('/')}
        style={{
          height: 52, width: '100%',
          backgroundColor: '#FF5C36', color: '#ffffff',
          border: 'none', borderRadius: 14,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 700, fontSize: 14, cursor: 'pointer',
        }}
      >{t('returnHome')}</button>
    </div>
  );

  return (
    <div style={{
      backgroundColor: '#f8f5ff',
      minHeight: '100dvh',
      paddingTop: 56,
      paddingBottom: 100,
      fontFamily: "'Be Vietnam Pro', sans-serif",
    }}>
      <TopBar showBack closeIcon />

      <div style={{ maxWidth: 480, margin: '0 auto', padding: '16px 24px' }}>

        {/* ── Error Mode Tabs ──────────────────────── */}
        <div style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr 1fr',
          backgroundColor: '#ffffff',
          padding: '10px 8px',
          marginBottom: 24,
          marginLeft: -24, marginRight: -24,
          boxShadow: '0 2px 8px rgba(45,45,66,0.04)',
        }}>
          {TABS.map(({ key, label }) => {
            const active = type === key;
            return (
              <button
                key={key}
                onClick={() => navigate(`/error?type=${key}`, { replace: true })}
                style={{
                  padding: '8px 4px',
                  border: 'none', cursor: 'pointer',
                  backgroundColor: active ? '#FF5C36' : 'transparent',
                  color: active ? '#ffffff' : '#5a5971',
                  borderRadius: 10,
                  fontFamily: "'Be Vietnam Pro', sans-serif",
                  fontWeight: active ? 700 : 500,
                  fontSize: 13,
                  boxShadow: active ? '0 2px 8px rgba(255,92,54,0.2)' : 'none',
                  transition: 'all 0.2s',
                }}
              >
                {label}
              </button>
            );
          })}
        </div>

        {type === 'expired'      && <ExpiredContent />}
        {type === 'insufficient' && <InsufficientContent />}
        {type === 'used'         && <UsedContent />}
      </div>

      <BottomNav />
    </div>
  );
}
